import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b86bst3pf8: FaireBrandEntity = {
  token: "b_b86bst3pf8",
  type: "brand",
  name: "Mama Liang's",
  avatarUrl:
    "https://cdn.faire.com/fastly/cb29b8ddc659a65b81deb784e150f0a441ccc8c77054c8a7d2b3dee36f058d78.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bd4eed4839e4a1b4fa136f421bd8c6c36ed785e1edecead30bacd807d19aa9e3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cb29b8ddc659a65b81deb784e150f0a441ccc8c77054c8a7d2b3dee36f058d78.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bd4eed4839e4a1b4fa136f421bd8c6c36ed785e1edecead30bacd807d19aa9e3.png",
  location: "Cupertino, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isTopShop: true,
  isInsider: true,
  description:
    "Mama Liang’s is the retail evolution of our family’s iconic Taiwanese restaurant, Liang’s Village in Cupertino, California. Founded in 1981 by our grandmother, the business is now led by its third generation: siblings Jessica, Erica, and Austin.\n\nWe established Mama Liang’s in 2017 in response to years of demand from customers wanting to recreate our signature flavors at home. Since then, we've expanded into stores across the US, bringing our heritage recipes to a national audience.\n\nCurrently, we offer three of our classic, high-velocity items for wholesale: our two Signature Chili Oils and our Cold Peanut Noodles. These are firm crowd favorites that drive repeat customers and offer a perfect \"quick-meal\" solution. We hope to add more of our products to our wholesale catalogue soon.\n\nWe’re proud to share the vibrancy and warmth of our culture through food that stays true to its roots. By bringing Mama Liang's to your shelves, you’re offering your customers more than just a pantry staple - you're sharing a 40+ year family legacy that started at our grandmother’s table.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:34.172Z",
    importedBy: "entity-db-cli",
  },
};
